/**
 * REVEAL
 *
 * Entrance transition on viewport entry
 *
 * USAGE
 * 	- Add classname 'js-reaveal' to initialize an element
 *  - Apply additional data attributes as options to control behaviour
 *
 * DATA ATTRIBUTE OPTIONS
 *  data-reveal-style				Select the type of transition. Default: "fade"
 *  data-reveal-speed				Transition speed in ms. Default: 500
 *  data-reveal-delay				Transition delay in ms. Default: 0
 *  data-reveal-include-children	Selector for children reveal objects that should trigger together with this element. Default: ''
 *  data-reveal-viewport-offset		(Viewport height factor) How far from viewport top should it trigger transition. Default: 0.5 (half the viewport height)
 *  data-reveal-enabled-breakpoint	At which breakpoint should transition apply.
 *  								Multiple breakpoints should be comma separated. e.g. "small,tablet" Default: "medium,large,xlarge"
 *
 * AVAILABLE TRANSITIONS
 *  fade (default)
 *  slide-right
 *  slide-left
 *  slide-up
 *  slide-down
 *  zoom-in
 *  zoom-out
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		element: '.js-reveal',
	};
	var CLASSNAME = {
		enabled: 'js-reveal--enabled',
		visible: 'js-reveal--visible',
		transitionDone: 'js-reveal--done',
	};
	var DATA_ATTRIBUTE_OPTIONS = {
		'revealStyle': 'string',
		'revealSpeed': 'float',
		'revealDelay': 'float',
		'revealViewportOffset': 'float',
		'revealEnabledBreakpoint': 'array',
		'revealIncludeChildren': 'string',
	};
	var DEFAULTS = {
		'revealStyle': 'fade',
		'revealSpeed': 500,
		'revealDelay': 0,
		'revealViewportOffset': 1,
		'revealEnabledBreakpoint': 'medium,large,xlarge',
		'revealIncludeChildren': '',
	};
	var TRANSITION_END_EVENT = 'transitionend';
	var SCROLL_LISTENERS = [];
	var RESIZE_LISTENERS = [];
	var BREAKPOINT_LISTENERS = [];

	var $window = $(window);
	var currentBreakpoint,
		currentScroll,
		windowWidth,
		windowHeight;

	/**
	 * REVEAL CLASS
	 */
	var Reveal = function ($element) {
		var _this = this;

		// Just ensure we have a jQuery object here
		this.$element = $($element);
		this.element = this.$element[0];
		this.options = $.extend( {}, DEFAULTS, Reveal.getElementOptions( this.$element ) );

		this.$element.css({
			'transition-duration'		: (this.options.revealSpeed / 1000) + 's',
			'transition-delay'			: (this.options.revealDelay / 1000) + 's',
		});

		// Add revealEnabledBreakpoint data attribute for CSS selection
		if ( this.$element.data( 'revealEnabledBreakpoint' ) === undefined ) {
			this.$element.attr( 'data-reveal-enabled-breakpoint', this.options.revealEnabledBreakpoint );
		}

		// Alot enough time to compute layout
		setTimeout(function () {
			if ( !_this.revealEnabledBreakpoint ) {
				_this.enable();
			} else {
				_this.onBreakpointChange();
			}
		}, 1000);

		// Attach as element data for external access
		this.$element.data('revealInstance', this);
	};

	/**
	 * REVEAL PROTOTYPE
	 */
	Reveal.prototype = $.extend({}, Reveal.prototype, {


		enable: function () {
			var _this = this;

			setTimeout(function () {
				_this.getChildren();
				_this.bindTransition();
				_this.bindListeners();
				_this.$element.addClass( CLASSNAME.enabled );
				_this.enabled = true;

				_this.updateMetrics();
				_this.onScroll();
			}, 1);
		},

		getChildren: function () {
			if ( !this.options.revealIncludeChildren ) { return; }
			this.$revealChildren = this.$element.find(this.options.revealIncludeChildren);
		},

		bindTransition: function  () {
			var _this = this;

			this.$element
			.bind(TRANSITION_END_EVENT, function ( e ) {
				if ( e.target !== _this.element || !_this.$element.hasClass( CLASSNAME.visible ) ) { return; }
				_this.setDone();
			});
		},

		updateMetrics: function () {
			var _this = this;

			// Reset layout to properly compute offsets
			this.$element.removeClass( CLASSNAME.enabled );
			this.topOffset = this.$element.offset().top;
			this.targetScroll = this.topOffset - ( windowHeight * this.options.revealViewportOffset );

			setTimeout( function () {
				_this.$element.addClass( CLASSNAME.enabled );
			}, 1);
		},

		onResize: function () {
			this.updateMetrics();
		},

		onScroll: function () {
			if ( currentScroll < this.targetScroll || !this.enabled || this.triggered ) { return; }
			this.reveal();
		},

		bindListeners: function () {
			this.resizeListenerIndex = RESIZE_LISTENERS.push( this.onResize.bind(this) ) - 1;
			this.scrollListenerIndex = SCROLL_LISTENERS.push( this.onScroll.bind(this) ) - 1;
			this.onResize();
			this.onScroll();

			if ( this.revealEnabledBreakpoint ) {
				this.breakpointListenerIndex = BREAKPOINT_LISTENERS.push( this.onBreakpointChange.bind(this) ) - 1;
				this.onBreakpointChange();
			}
		},

		reveal: function () {
			this.triggered = true;
			// Proceed animation
			this.$element.addClass( CLASSNAME.visible );

			if ( !this.$revealChildren || !this.$revealChildren.length ) { return; }

			// Reveal included children if any
			this.$revealChildren.each(function ( index, _element ) {
				var childReveal = $(_element).data('revealInstance');
				if ( !childReveal || childReveal.triggered ) { return; }
				childReveal.reveal();
			});
		},

		// Handles post-transition
		setDone: function () {
			this.$element.addClass( CLASSNAME.transitionDone ).unbind( TRANSITION_END_EVENT );
			this.done = true;

			// Remove scroll listener
			if ( this.scrollListenerIndex !== undefined ) {
				SCROLL_LISTENERS[this.scrollListenerIndex] = undefined;
			}
			// remove resize listener
			if ( this.resizeListenerIndex !== undefined ) {
				RESIZE_LISTENERS[this.resizeListenerIndex] = undefined;
			}
			// remove breakpoint listener
			if ( this.breakpointListenerIndex !== undefined ) {
				BREAKPOINT_LISTENERS[this.breakpointListenerIndex] = undefined;
			}
		}
	});

	/**
	 * REVEAL CLASS STATIC METHODS
	 */

	// Parses Reveal options from a given element
	Reveal.getElementOptions = function ( $element ) {

		$element = $($element); // [JB] NOTE: Just making sure we have a jQuery object here
		var elementData = $element.data();
		var elementRevealOptions = {};

		for ( var optionName in DATA_ATTRIBUTE_OPTIONS ) {
			if ( !(optionName in elementData) ) { continue; }
			var optionValue = elementData[optionName];
			var optionType = DATA_ATTRIBUTE_OPTIONS[optionName];

			switch ( optionType ) {
				case 'float': optionValue = parseFloat( optionValue ); break;
				case 'list' : optionValue = optionValue.trim().split(','); break;
			}

			elementRevealOptions[optionName] = optionValue;
		}

		return elementRevealOptions;
	};

	/**
	 * PRIVATE FUNCTIONS
	 */
	function onScroll () {
		currentScroll = window.pageYOffset;
		SCROLL_LISTENERS.forEach(function ( _listener ) {
			if ( typeof _listener === 'function' ) { _listener(); }
		});
	}

	function onResize () {
		windowWidth = $window.outerWidth();
		windowHeight = $window.outerHeight();
		RESIZE_LISTENERS.forEach(function ( _listener ) {
			if ( typeof _listener === 'function' ) { _listener(); }
		});
	}

	function onBreakpointChange () {
		currentBreakpoint = VP.breakpoint.currentBreakpoint;
		// console.log("[reveal] breakpoint change");
		BREAKPOINT_LISTENERS.forEach(function ( _listener ) {
			if ( typeof _listener === 'function' ) { _listener(); }
		});
	}

	/**
	 * NEWSLETTER MODULE ATTACHED TO APP
	 */
	VP.reveal = {
		$elements: $(SELECTOR.element),
		instances: [],

		init: function () {
			var _this = this;

			// Bind window events
			$(window)
			.bind( 'resize', VP.helpers.debounce( onResize ) )
			.bind( 'scroll', onScroll )
						.bind( 'load', function () {
								// Initial triggers
								onResize();
								onScroll();
						});

						// Initial triggers to save scroll and window size
			onResize();
			onScroll();

			_this.$elements.each(function () {
				var _options =
				_this.instances.push(new Reveal( this ));
			});

			// TODO: Implement breakpointchange once breakpoint module
			// is merged into master
			VP.breakpoint.onChange( onBreakpointChange );

			// allow hash links outside of menu to link to menu items
			$(document).on('click', "a[href*='#']", function (e) {
				if ($(this).parents(".vp-quicklinks").length > 0) {
					return;
				}
				var href = $(this).attr("href");
				var hashlink = $.trim(href.substring(href.indexOf('#')));
				var urllink = $.trim(href.substring(0, href.indexOf('#')));
				var currentpage = $.trim(window.location.href.split("#")[0]);
				var absolutelink = currentpage.replace(window.location.origin,"");
				var samepage = (urllink == currentpage || urllink == absolutelink || urllink == "");

				if (hashlink == "#" || hashlink == "#pr-nav-deep") {
					return;
				}

				// console.log("hashlink: " + hashlink);
				// console.log("urllink: " + urllink);
				// console.log("currentpage: " + currentpage);
				// console.log("absolutelink: " + absolutelink);
				// console.log("samepage: " + samepage);


				hashlinkalt = hashlink.replace("#","#quicklinks-reference_");

				var $qlink = $(".vp-quicklinks a[href='"+hashlink+"'],.vp-quicklinks a[href='"+hashlinkalt+"']");
				var $inpagelink = $(hashlink);

				if (samepage) {
					//console.log("samepage");
					if ($qlink.length == 1) {
						// trigger quicklinks link
						$qlink.trigger("click");
						return false;
					}
					else if ($inpagelink.length == 1) {
						// check for story tracker links
						//console.log("inpagelink");
						var $storyitem = $inpagelink.parent(".vp-story__item");

						if ($storyitem.length == 1 && VP.storyTracker.isInit) {
							//console.log("story item");
								var stype = $storyitem.data("type");
								if (stype == "breaker") {
									var bid  = $storyitem.data("breakerid");
									VP.storyTracker.scrollToItem( bid , true );
									return true;
								}
								else if (stype == "article-section") {
									var sid  = $storyitem.data("value");
									VP.storyTracker.scrollToItem( sid );
									return true;
								}
						}
						else {
							var _maxSpeed = VP.storyTracker.getMaxSpeed();
							var _offset = 0;
							var _top = $inpagelink.offset().top - VP.nav.wrapper.outerHeight() - _offset;
							//console.log("standard scroll item");

							if (VP.storyTracker.isIE11) {
								$( "html, body" ).scrollTop(_top);
							} else {
								$( "html, body" ).animate( { scrollTop: _top + "px" }, _maxSpeed, function() {
								});
							}
							return true;
						}
					}
				}

				return;
			});


		},
		/*
		 * For use on other modules that resize the page
		 * This function updates the Reveal metrics so the modules fadein properly
		 */
		updatePosition: function() {
			if (this.instances) {
				this.instances.forEach(function( obj, i ) {
					obj.updateMetrics();
				});
			}
		}
	};
})(jQuery);
